import { render, staticRenderFns } from "./yaoqing.vue?vue&type=template&id=0ed7f215&"
import script from "./yaoqing.vue?vue&type=script&lang=js&"
export * from "./yaoqing.vue?vue&type=script&lang=js&"
import style0 from "./yaoqing.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports